<template>
  <NavBarApp />
  <router-view />
  <FooterApp />
</template>

<script>
import NavBarApp from './components/NavBarApp.vue'
import FooterApp from './components/FooterApp.vue'

export default {
  name: 'App',
  components: {
    NavBarApp,
    FooterApp
  }
}
</script>

<style>

</style>
